import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtPeerGroupItem {
    tenantId: number;
    peerGroupId: number;
    peerGroupDefaultInitials: string;
    peerGroupDefaultShortName: string;
    peerGroupDefaultName: string;
    clientTranslationTextId: number;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
    languageID: number;
}

export interface PeerGroupItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
    enabled: boolean;
}

class PeerGroupItemModelTransformer
    implements ModelTransformer<PeerGroupItem, ExtPeerGroupItem>
{
    transform(model: ExtPeerGroupItem): PeerGroupItem {
        return {
            id: model.peerGroupId,
            initials: model.peerGroupDefaultInitials,
            shortName: model.peerGroupDefaultShortName,
            name: model.peerGroupDefaultName,
            enabled: model.enabled,
        };
    }
}

export class PeerGroupItemModelSetTransformer extends ModelSetTransformer<
    PeerGroupItem,
    ExtPeerGroupItem
> {
    protected newTransformer(): ModelTransformer<
        PeerGroupItem,
        ExtPeerGroupItem
    > {
        return new PeerGroupItemModelTransformer();
    }
}
